// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"112":"72ca3375","372":"a6b540fd"}[chunkId] + ".chunk.css");